// libs
import React from 'react';

// components
import { Stack } from '@lyearn/ui';
import ReviewCardListItem from '@/modules/skills/views/SkillReviewSubmission/components/SkillUserReview/components/ReviewCardListItem';
import { ReviewCardDetailProps } from '@/modules/skills/views/SkillReviewSubmission/components/SkillUserReview/components/ReviewCardListItem/types';
import { SkillType } from '@/types/schema';

// types
import { ReviewCardDetailsProps } from './types';

function ReviewCardList(props: ReviewCardDetailsProps) {
  const { skills, onChange, feedbackSkillData, removeSkill, isMindset } = props;

  // TODO: @aryan02420 change signature of onChange in props
  const onChangeCallback = React.useCallback<NonNullable<ReviewCardDetailProps['onChange']>>(
    ({ id, score }) => {
      onChange?.(id, score);
    },
    [onChange],
  );

  return (
    <>
      {skills?.length ? (
        <Stack className="mb-16" direction="col" gapY={32}>
          {skills?.map((skill) => {
            return (
              <ReviewCardListItem
                key={skill.id}
                isMindset={isMindset}
                removeSkill={removeSkill}
                score={feedbackSkillData?.[skill.id]}
                showScoreLabel={false}
                skill={skill as SkillType}
                onChange={onChangeCallback}
              />
            );
          })}
        </Stack>
      ) : null}
    </>
  );
}

export default React.memo(ReviewCardList);
